import { render, staticRenderFns } from "./SerasaFile.vue?vue&type=template&id=6d18e16c"
import script from "./SerasaFile.vue?vue&type=script&lang=ts"
export * from "./SerasaFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports